export const styles = {
  carouselContainer: {
    buttons: {
      height: 62,
      width: 62,
    },
    className: '',
    flexShrink: 0,
    width: '100%',
  },
};
